// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","rotation":"Loader_rotation__zW3DX","rotationBack":"Loader_rotationBack__TJrrM"};